// MainWebsite
export const homepage = `/`;

// Common
export const aboutLink = `/aboutus`;
export const contactLink = `/contactus`;
export const TermsAndConditionsLink = `/terms-and-conditions`;
export const PrivacyPolicyLink = `/privacy-policy`;

// Profile
export const profileLink = `/profile`;
export const userInternshipsLink = `/myinternships`;

// Auth
export const loginLink = `/login`;
export const registerLink = `/register`;
export const forgotPasswordLink = `/forgot-password`;
export const verifyOtpLink = `/verify-otp`;
export const resetPasswordLink = `/reset-password`;

// Internships
export const internshipLink = `/internships`;
export const internshipID = `:internshipID`;

// FAQs
export const faqLink = `/faq`;

// Explore
export const exploreLink = `/explore`;
